import { FieldType } from 'types';
import AddressInput from './AddressInput';
import BirthdayInput from './BirthdayInput';
import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup';
import DateInput from './DateInput';
import MultiText from './MultiText';
import NativeSelect from './NativeSelect';
import NumberInput from './NumberInput';
import RadioGroup from './RadioGroup';
import RegoInput from './RegoInput';
import SearchInput from './SearchInput';
import Select from './Select';
import VehicleSelect from './VehicleSelect';
import TextArea from './TextArea';
import TextInput from './TextInput';
import RadioV3Group from '../form-fields-v3/Radio';

const FieldTypeMap = {
  [FieldType.Address]: AddressInput,
  [FieldType.Birthday]: BirthdayInput,
  [FieldType.Checkbox]: Checkbox,
  [FieldType.CheckboxGroup]: CheckboxGroup,
  [FieldType.Date]: DateInput,
  [FieldType.MultiText]: MultiText,
  [FieldType.NativeSelect]: NativeSelect,
  [FieldType.Number]: NumberInput,
  [FieldType.Radio]: RadioGroup,
  [FieldType.RadioV3]: RadioV3Group,
  [FieldType.Rego]: RegoInput,
  [FieldType.VehicleSelect]: VehicleSelect,
  [FieldType.Search]: SearchInput,
  [FieldType.Select]: Select,
  [FieldType.TextArea]: TextArea,
  [FieldType.Text]: TextInput,
};

export {
  FieldTypeMap,
  AddressInput,
  DateInput,
  BirthdayInput,
  NativeSelect,
  NumberInput,
  RadioGroup,
  SearchInput,
  Select,
  TextArea,
  TextInput,
  VehicleSelect,
};
